/* eslint-disable */
export const MODE = process.env.MODE;
export const API_BASE_URL = process.env.API_BASE_URL;
export const APP_BASE_URL = process.env.APP_BASE_URL;
export const APP_AGENT_URL = process.env.APP_AGENT_URL;
export const ERROR_REPORTING_KEY = process.env.ERROR_REPORTING_KEY;
export const ERROR_REPORTING_PROJECT = process.env.ERROR_REPORTING_PROJECT;
export const LOGOUT_URL = process.env.LOGOUT_URL;
export const USE_PAGE_VIEW = process.env.USE_PAGE_VIEW === 'true';
export const PROFFIT_SEARCH_COLUMN_EXTERNAL_PATH = process.env.PROFFIT_SEARCH_COLUMN_EXTERNAL_PATH;
export const GIT_COMMIT_HASH = process.env.GIT_COMMIT_HASH || '';
export const IS_MODE_REGRESSION = process.env.MODE === 'REGRESSION';
